import * as Colors from 'ui-library/Colors';
import {COMMON_NODE_WIDTH} from 'ui-library/reactflow/nodes/BenchlingNode/BenchlingNodeDesignConstants';

export const ANALYSIS_FLOWCHART_NODE_WIDTH = COMMON_NODE_WIDTH;

export const ANALYSIS_FLOWCHART_EDGE_LABEL_ICON_HEIGHT = 14;

export const ANALYSIS_FLOWCHART_BACKGROUND = Colors.GRAY_LIGHTER;
export const ANALYSIS_FLOWCHART_NODE_COLOR = Colors.WHITE;
export const ANALYSIS_FLOWCHART_NODE_ERROR_COLOR = Colors.RED_LIGHT;
